module.exports = __webpack_public_path__ + "img/alex.ed0e1b04.png";